import { INVOICE_TYPE } from '@ekuaibao/lib/lib/enums';
import { formatInvoiceData } from '../../InvoiceCard/FormatInvoiceData';
import moment from 'moment';
import { getTitleByInvoiceMark } from "../../InvoiceCard/InvoiceItem";
export var invoiceInfoFuncMap = {
    system_发票主体: getAddInvoiceInfo,
    system_出租车票: getTaxiInvoiceInfo,
    system_过路费发票: getTollInvoiceInfo,
    system_定额发票: getQuotaInvoiceInfo,
    system_火车票: getTrainInvoiceInfo,
    system_航空运输电子客票行程单: getPlaneInvoiceInfo,
    system_客运汽车发票: getBusInvoiceInfo,
    system_其他: getOtherInvoiceInfo,
    system_机打发票: getMachineInvoiceInfo,
    system_医疗发票: getMedicalInvoiceInfo,
    system_非税收入类票据: getNontaxInvoiceInfo,
    system_消费小票: getShoppingInvoiceInfo,
    system_海外发票: getOverseasInvoiceInfo,
    invoicePhoto: getPhotoInvoiceInfo
};
export var ReviewedInvoiceTypes = Object.keys(invoiceInfoFuncMap);
function getAddInvoiceInfo(item) {
    var _a;
    var _b = formatInvoiceData({ data: item, dateFormat: i18n.get('YYYY年MM月DD日') }).invoiceInfo, invoiceInfo = _b === void 0 ? {} : _b;
    var masterItems = invoiceInfo.masterItems, invoiceType = invoiceInfo.type, totalAmount = invoiceInfo.invamt, details = invoiceInfo.detailItems;
    var title = getTitleByInvoiceMark((_a = item === null || item === void 0 ? void 0 : item.master) === null || _a === void 0 ? void 0 : _a.form, invoiceInfo);
    var _c = item.master.form, E_税额 = _c.E_税额, E_是否抵扣 = _c.E_是否抵扣;
    return {
        typeName: INVOICE_TYPE()[invoiceType],
        title: title,
        allMoney: totalAmount,
        taxAmount: E_税额,
        isDeduction: E_是否抵扣,
        details: details,
        dateOrInfo: masterItems.filter(function (i) { return i.type === 'date'; })[0].value
    };
}
function getTaxiInvoiceInfo(item) {
    var _a = item.master.form, E_system_出租车票_发票所在地 = _a.E_system_出租车票_发票所在地, E_system_出租车票_上车时间 = _a.E_system_出租车票_上车时间, E_system_出租车票_下车时间 = _a.E_system_出租车票_下车时间, E_system_出租车票_里程 = _a.E_system_出租车票_里程, E_system_出租车票_金额 = _a.E_system_出租车票_金额;
    var taxi_date = moment(E_system_出租车票_上车时间).format(i18n.get('YYYY年MM月DD日 HH:mm')) + "-" + moment(E_system_出租车票_下车时间).format('HH:mm');
    var km = E_system_出租车票_里程 ? E_system_出租车票_里程 + "km" : '';
    return {
        title: E_system_出租车票_发票所在地 ? "\u51FA\u79DF\u8F66\u53D1\u7968 (" + E_system_出租车票_发票所在地 + ")" : '',
        allMoney: E_system_出租车票_金额 ? E_system_出租车票_金额 : '',
        typeName: i18n.get('出租车票'),
        dateOrInfo: taxi_date + " " + km
    };
}
function getTollInvoiceInfo(item) {
    var _a = item.master.form, E_system_过路费发票_时间 = _a.E_system_过路费发票_时间, E_system_过路费发票_入口 = _a.E_system_过路费发票_入口, E_system_过路费发票_出口 = _a.E_system_过路费发票_出口, E_system_过路费发票_金额 = _a.E_system_过路费发票_金额;
    var start = E_system_过路费发票_入口 ? E_system_过路费发票_入口 : '';
    var end = E_system_过路费发票_出口 ? E_system_过路费发票_出口 : '';
    return {
        title: start + " -- " + end,
        allMoney: E_system_过路费发票_金额,
        typeName: i18n.get('过路费票'),
        dateOrInfo: moment(E_system_过路费发票_时间).format(i18n.get('YYYY年MM月DD日 HH:mm'))
    };
}
function getQuotaInvoiceInfo(item) {
    var E_system_定额发票_金额 = item.master.form.E_system_定额发票_金额;
    return {
        title: i18n.get('定额发票'),
        allMoney: E_system_定额发票_金额 ? E_system_定额发票_金额 : '',
        typeName: i18n.get('定额发票'),
        dateOrInfo: ''
    };
}
function getTrainInvoiceInfo(item) {
    var _a = item.master.form, E_system_火车票_乘车时间 = _a.E_system_火车票_乘车时间, E_system_火车票_上车车站 = _a.E_system_火车票_上车车站, E_system_火车票_下车车站 = _a.E_system_火车票_下车车站, E_system_火车票_金额 = _a.E_system_火车票_金额, E_税额 = _a.E_税额, E_是否抵扣 = _a.E_是否抵扣;
    var trainDate = moment(E_system_火车票_乘车时间).format(i18n.get('YYYY年MM月DD日 HH:mm'));
    var start = E_system_火车票_上车车站 ? E_system_火车票_上车车站 : '';
    var end = E_system_火车票_下车车站 ? E_system_火车票_下车车站 : '';
    return {
        title: start + " -- " + end,
        allMoney: E_system_火车票_金额,
        taxAmount: E_税额,
        isDeduction: E_是否抵扣,
        typeName: i18n.get('铁路客票'),
        dateOrInfo: trainDate
    };
}
function getPlaneInvoiceInfo(item) {
    var _a = item.master.form, E_system_航空运输电子客票行程单_乘机时间 = _a.E_system_航空运输电子客票行程单_乘机时间, E_system_航空运输电子客票行程单_出发站 = _a.E_system_航空运输电子客票行程单_出发站, E_system_航空运输电子客票行程单_到达站 = _a.E_system_航空运输电子客票行程单_到达站, E_system_航空运输电子客票行程单_金额 = _a.E_system_航空运输电子客票行程单_金额, E_税额 = _a.E_税额, E_是否抵扣 = _a.E_是否抵扣;
    var planeDate = moment(E_system_航空运输电子客票行程单_乘机时间).format(i18n.get('YYYY年MM月DD日 HH:mm'));
    var start = E_system_航空运输电子客票行程单_出发站 ? E_system_航空运输电子客票行程单_出发站 : '';
    var end = E_system_航空运输电子客票行程单_到达站 ? E_system_航空运输电子客票行程单_到达站 : '';
    return {
        title: start + " -- " + end,
        allMoney: E_system_航空运输电子客票行程单_金额,
        taxAmount: E_税额,
        isDeduction: E_是否抵扣,
        typeName: i18n.get('机票行程单'),
        dateOrInfo: planeDate
    };
}
function getBusInvoiceInfo(item) {
    var _a = item.master.form, E_system_客运汽车发票_时间 = _a.E_system_客运汽车发票_时间, E_system_客运汽车发票_出发车站 = _a.E_system_客运汽车发票_出发车站, E_system_客运汽车发票_达到车站 = _a.E_system_客运汽车发票_达到车站, E_system_客运汽车发票_金额 = _a.E_system_客运汽车发票_金额, E_税额 = _a.E_税额, E_是否抵扣 = _a.E_是否抵扣;
    var start = E_system_客运汽车发票_出发车站 ? E_system_客运汽车发票_出发车站 : '';
    var end = E_system_客运汽车发票_达到车站 ? E_system_客运汽车发票_达到车站 : '';
    return {
        title: start + " -- " + end,
        allMoney: E_system_客运汽车发票_金额,
        taxAmount: E_税额,
        isDeduction: E_是否抵扣,
        typeName: i18n.get('客运汽车票'),
        dateOrInfo: "" + moment(E_system_客运汽车发票_时间).format(i18n.get('YYYY年MM月DD日 HH:mm'))
    };
}
function getMedicalInvoiceInfo(item) {
    var _a = item.master.form, E_system_医疗发票_开票日期 = _a.E_system_医疗发票_开票日期, E_system_医疗发票_金额合计 = _a.E_system_医疗发票_金额合计, E_system_医疗发票_发票种类 = _a.E_system_医疗发票_发票种类;
    return {
        title: "" + E_system_医疗发票_发票种类,
        allMoney: E_system_医疗发票_金额合计,
        typeName: i18n.get('医疗发票'),
        dateOrInfo: moment(E_system_医疗发票_开票日期).format(i18n.get('YYYY年MM月DD日'))
    };
}
function getNontaxInvoiceInfo(item) {
    var _a = item.master.form, E_system_非税收入类票据_开票日期 = _a.E_system_非税收入类票据_开票日期, E_system_非税收入类票据_金额合计 = _a.E_system_非税收入类票据_金额合计, E_system_非税收入类票据_发票种类 = _a.E_system_非税收入类票据_发票种类, E_system_非税收入类票据_发票类别 = _a.E_system_非税收入类票据_发票类别, E_system_非税收入类票据_收款单位 = _a.E_system_非税收入类票据_收款单位;
    return {
        title: E_system_非税收入类票据_发票种类 || E_system_非税收入类票据_收款单位,
        allMoney: E_system_非税收入类票据_金额合计,
        typeName: E_system_非税收入类票据_发票类别,
        dateOrInfo: moment(E_system_非税收入类票据_开票日期).format(i18n.get('YYYY年MM月DD日'))
    };
}
function getMachineInvoiceInfo(item) {
    var _a = item.master.form, E_system_机打发票_时间 = _a.E_system_机打发票_时间, E_system_机打发票_金额 = _a.E_system_机打发票_金额, E_system_机打发票_销售方名称 = _a.E_system_机打发票_销售方名称, E_税额 = _a.E_税额, E_是否抵扣 = _a.E_是否抵扣;
    return {
        title: "" + E_system_机打发票_销售方名称,
        allMoney: E_system_机打发票_金额,
        taxAmount: E_税额,
        isDeduction: E_是否抵扣,
        typeName: i18n.get('机打发票'),
        dateOrInfo: moment(E_system_机打发票_时间).format(i18n.get('YYYY年MM月DD日'))
    };
}
function getOtherInvoiceInfo(item) {
    var _a = item.master.form, E_system_其他_日期 = _a.E_system_其他_日期, E_system_其他_金额 = _a.E_system_其他_金额;
    return {
        title: i18n.get('其他票据'),
        allMoney: E_system_其他_金额,
        typeName: i18n.get('其他票据'),
        dateOrInfo: moment(E_system_其他_日期).format(i18n.get('YYYY年MM月DD日'))
    };
}
function getOverseasInvoiceInfo(item) {
    var _a = item.master.form, E_system_海外发票_日期 = _a.E_system_海外发票_日期, E_system_海外发票_金额 = _a.E_system_海外发票_金额;
    return {
        title: i18n.get('海外票据'),
        allMoney: E_system_海外发票_金额,
        typeName: i18n.get('海外票据'),
        dateOrInfo: moment(E_system_海外发票_日期).format(i18n.get('YYYY年MM月DD日'))
    };
}
function getShoppingInvoiceInfo(item) {
    var _a = item.master.form, E_system_消费小票_时间 = _a.E_system_消费小票_时间, E_system_消费小票_金额 = _a.E_system_消费小票_金额, E_system_消费小票_店名 = _a.E_system_消费小票_店名, E_税额 = _a.E_税额, E_是否抵扣 = _a.E_是否抵扣;
    return {
        title: "" + E_system_消费小票_店名,
        allMoney: E_system_消费小票_金额,
        taxAmount: E_税额,
        isDeduction: E_是否抵扣,
        typeName: i18n.get('消费小票'),
        dateOrInfo: moment(E_system_消费小票_时间).format(i18n.get('YYYY年MM月DD日'))
    };
}
export function getPhotoInvoiceInfo(item, details) {
    var entity = item.type;
    var photoInvoiceInfo = {
        id: '',
        title: item.fileName,
        allMoney: '',
        typeName: i18n.get('发票照片'),
        dateOrInfo: '',
        imageSrc: item.url,
        hasPDF: false,
        formData: {},
        entity: entity
    };
    var detailItemIndex = details === null || details === void 0 ? void 0 : details.findIndex(function (detail) {
        var _a;
        var attachments = ((_a = detail.feeTypeForm.invoiceForm) === null || _a === void 0 ? void 0 : _a.attachments) || [];
        return !!attachments.find(function (el) { var _a; return item.fileId === ((_a = el.fileId) === null || _a === void 0 ? void 0 : _a.id); });
    });
    var detailItem = details[detailItemIndex];
    if (detailItem) {
        photoInvoiceInfo['feeDetailAmount'] = detailItem.feeTypeForm.amount;
        photoInvoiceInfo['feeDetailName'] = detailItem.feeTypeId.fullname;
        photoInvoiceInfo['detailNo'] = detailItemIndex;
    }
    return photoInvoiceInfo;
}
export function calculateTotalMoneyOfDetails(items) {
    var totalAmount = 0;
    var totalTaxAmount = 0;
    items.forEach(function (v) {
        if (v.amount) {
            if (typeof v.amount === 'number' || typeof v.amount === 'string') {
                totalAmount += Number(v.amount);
            }
            else {
                totalAmount += Number(v.amount.standard);
            }
        }
        if (v.tax) {
            if (typeof v.tax === 'number' || typeof v.tax === 'string') {
                totalTaxAmount += Number(v.tax);
            }
            else {
                totalTaxAmount += Number(v.tax.standard);
            }
        }
    });
    return { totalAmount: totalAmount, totalTaxAmount: totalTaxAmount };
}
